import axios from "axios";
import {SERLI_API_URL} from "@/common/config";

const initialState = {
    returnRoute: null,
    productDatas: null,
    firstname: '',
    lastname: '',
    email: '',
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setReturnRoute(state, route) {
            state.returnRoute = route;
        },
        setProductDatas(state, datas) {
            state.productDatas = datas;
        },
        setFirstname(state, datas) {
            state.firstname = datas;
        },
        setLastname(state, datas) {
            state.lastname = datas;
        },
        setEmail(state, datas) {
            state.email = datas;
        }
    }
};